module.exports = __webpack_public_path__ + "img/about-more.dc43711.svg";